import {
    Accordion, AccordionDetails, AccordionSummary,
    Alert,
    Box,
    Grid, IconButton, LinearProgress,
    Stack, TextField,
    Tooltip,
    Typography
} from "@mui/material";
import styles from '../css/Home.module.css';
import {Formik, useFormikContext} from "formik";
import {useNavigate} from "react-router-dom";
import {
    getCarDisplacement,
    getCarFuels,
    getCarMakes,
    getCarModels,
    getCarSeries,
} from "../serverREST";

import {useDispatch, useSelector} from "react-redux";
import {setDisplacements, setFuels, setListsEmpty, setMakes, setModels, setSeries} from "../redux/listsSlice";
import React, {useEffect, useRef, useState, useCallback, useMemo} from "react";
import {setJobs} from "../redux/jobsSlice";

import Autocomplete from "@mui/material/Autocomplete";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import {DatePickerRangeDays, ListSearchCar, CarCard, LicensePlateInput} from "../components";
import debounce from "../utils/debounce";
import {fixLayoutLang} from "../utils/keyboardLayout";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {VirtualizedCarCard} from "../components/VirtualizedCarCard";

function ChooseCar() {
    const loader = useSelector(state => state.lists.carLoader)

    let currentYear = new Date().getFullYear(), years = [];
    let startYear = 1980;
    while (startYear <= currentYear) {
        years.push(String(startYear++));
    }
    years = years.reverse();

    const makes = useSelector(state => state.lists.makes);
    const series = useSelector(state => state.lists.series);
    const models = useSelector(state => state.lists.models)
    const fuels = useSelector(state => state.lists.fuels);
    const displacements = useSelector(state => state.lists.displacements)
    const dispatch = useDispatch();

    const {values, setFieldValue, submitForm} = useFormikContext();
    const [inputValue, setInputValue] = useState('');
    useEffect(() => {
        getCarModels(values.year, values.make, values.serie, (resp) => {
            if (!resp.data) {
                setFieldValue('model', null)
                submitForm()
            }
            if (resp.data && resp.data.length === 1) {
                setFieldValue('model', resp.data[0])
            }
            if (resp.data && resp.data.length !== 1) {
                modelRef.current.focus()
            }
        })
    }, [values.serie])

    useEffect(() => {
        getCarFuels(values.model, (resp) => {
            if (!resp.data) {
                setFieldValue('fuel', null)
                getCarDisplacement(values.model, values.fuel, (resp) => {
                    if (!resp.data) {
                        setFieldValue('displacement', null)
                        submitForm()
                    }
                    if (resp.data && resp.data.length === 1) {
                        setFieldValue('displacement', resp.data[0])
                        submitForm()
                    }
                })
            }
            if (resp.data && resp.data.length === 1) {
                setFieldValue('fuel', resp.data[0])
            }
            if (resp.data && resp.data.length !== 1) {
                fuelRef.current.focus()
            }
        })
    }, [values.model])

    useEffect(() => {
        getCarDisplacement(values.model, values.fuel, (resp) => {
            if (!resp.data) {
                setFieldValue('displacement', null)
                submitForm()
            }
            if (resp.data && resp.data.length === 1) {
                setFieldValue('displacement', resp.data[0])
                submitForm()
            }
            if (resp.data && resp.data.length !== 1) {
                displacementRef.current.focus()
            }
        })
    }, [values.fuel]);

    let today = new Date()

    const makeRef = useRef();
    const serieRef = useRef();
    const modelRef = useRef();
    const fuelRef = useRef();
    const displacementRef = useRef();
    return (
        <Grid container>
            <Grid item xs={2} sx={{m: 1, minWidth: '7em'}}>
                <Autocomplete
                    value={values.year}
                    autoSelect
                    autoHighlight
                    openOnFocus
                    noOptionsText={'Ничего не найдено'}
                    onChange={(event, newValue) => {
                        setFieldValue('year', newValue);
                        setFieldValue('make', null);
                        dispatch(setMakes([]))
                        setFieldValue('serie', null);
                        dispatch(setSeries([]))
                        setFieldValue('model', null);
                        dispatch(setModels([]))
                        setFieldValue('fuel', null);
                        dispatch(setFuels([]))
                        setFieldValue('displacement', null);
                        dispatch(setDisplacements([]))
                        getCarMakes(newValue, () => {
                            makeRef.current.focus()
                        })
                    }}
                    options={years}
                    renderInput={(params) => <TextField {...params} label="Год" variant={'standard'}/>}
                >
                </Autocomplete>
            </Grid>
            <Grid item xs={4} sx={{m: 1, minWidth: '7em'}}>
                {loader.makes ? <LinearProgress sx={{"marginTop": "45px"}}/> :
                    <Autocomplete
                        autoHighlight
                        openOnFocus
                        noOptionsText={'Ничего не найдено'}
                        disabled={values.year === null}
                        value={values.make}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'input') {
                                const fixed = fixLayoutLang(newInputValue.trim());
                                setInputValue(fixed);
                            }
                        }}
                        onChange={(event, newValue) => {
                            setInputValue(newValue.make);
                            setFieldValue('make', newValue);
                            setFieldValue('serie', null);
                            dispatch(setSeries([]))
                            setFieldValue('model', null);
                            dispatch(setModels([]))
                            setFieldValue('fuel', null);
                            dispatch(setFuels([]))
                            setFieldValue('displacement', null);
                            dispatch(setDisplacements([]))

                            getCarSeries(values.year, newValue, () => {
                                serieRef.current.focus()
                            })
                        }}
                        getOptionLabel={(option) => option.make}
                        options={makes}
                        renderInput={(params) => <TextField {...params}
                                                            inputRef={makeRef}
                                                            label="Марка"
                                                            variant={'standard'}/>}
                    >
                    </Autocomplete>}
            </Grid>
            <Grid item xs={4} sx={{m: 1, minWidth: '7em'}}>
                {loader.series ? <LinearProgress sx={{"marginTop": "45px"}}/> : <Autocomplete
                    autoHighlight
                    openOnFocus
                    noOptionsText={'Ничего не найдено'}
                    disabled={values.make === null}
                    value={values.serie}
                    onChange={(event, newValue) => {
                        setFieldValue('serie', newValue);
                        // console.log(1)
                        setFieldValue('model', null);
                        dispatch(setModels([]))
                        setFieldValue('fuel', null);
                        dispatch(setFuels([]))
                        setFieldValue('displacement', null);
                        dispatch(setDisplacements([]))
                    }}
                    getOptionLabel={(option) => option.serie}
                    options={series}
                    renderInput={(params) => <TextField {...params}
                                                        inputRef={serieRef}
                                                        label="Модель"
                                                        variant={'standard'}/>}
                >
                </Autocomplete>}
            </Grid>
            {
                models.length > 1 || loader.models ?
                    <Grid item xs={4} sx={{m: 1, minWidth: '7em'}}>
                        {loader.models ? <LinearProgress sx={{"marginTop": "45px"}}/> : <Autocomplete
                            autoHighlight
                            openOnFocus
                            noOptionsText={'Ничего не найдено'}
                            disabled={values.serie === null}
                            value={values.model}
                            onChange={(event, newValue) => {
                                setFieldValue('model', newValue);
                                setFieldValue('fuel', null);
                                dispatch(setFuels([]))
                                setFieldValue('displacement', null);
                                dispatch(setDisplacements([]))
                            }}
                            getOptionLabel={
                                (option) => (option.model_years ? option.model_years.replace(3000, today.getFullYear()) + ' ' : '') + (option.model_codes ? option.model_codes : '')}
                            options={models}
                            renderOption={(props, option) => (
                                <Box component="li" {...props}>
                                    <Stack direction={'row'} justifyContent={'space-between'} sx={{width: '100%'}}
                                           alignItems={'center'}>
                                        <div>
                                            {option.model_years ? option.model_years.replace(3000, today.getFullYear()) : ''}
                                        </div>
                                        <div>
                                            {option.model_codes ? option.model_codes : ''}
                                        </div>
                                    </Stack>
                                </Box>
                            )}
                            renderInput={(params) => <TextField {...params}
                                                                inputRef={modelRef}
                                                                label="Год производства и код модели"
                                                                variant={'standard'}/>}
                        >
                        </Autocomplete>}
                    </Grid>
                    : null
            }
            {
                fuels.length > 1 || loader.fuels ?
                    <Grid item xs={4} sx={{m: 1, minWidth: '7em'}}>
                        {loader.fuels ? <LinearProgress sx={{"marginTop": "45px"}}/> : <Autocomplete
                            autoHighlight
                            openOnFocus
                            noOptionsText={'Ничего не найдено'}
                            disabled={values.model === null}
                            value={values.fuel}
                            onChange={(event, newValue) => {
                                setFieldValue('fuel', newValue);
                                setFieldValue('displacement', null);
                                dispatch(setDisplacements([]))
                            }}
                            getOptionLabel={(option) => option.fuelName}
                            options={fuels}
                            renderInput={(params) => <TextField {...params}
                                                                inputRef={fuelRef}
                                                                label="Тип топлива"
                                                                variant={'standard'}/>}
                        >
                        </Autocomplete>}
                    </Grid>
                    : null

            }
            {
                displacements.length > 1 || loader.displacements ?
                    <Grid item xs={2} sx={{m: 1, minWidth: '13em'}}>
                        {loader.displacements ? <LinearProgress sx={{"marginTop": "45px"}}/> : <Autocomplete
                            autoHighlight
                            openOnFocus
                            noOptionsText={'Ничего не найдено'}
                            value={values.displacement}
                            onChange={(event, newValue) => {
                                setFieldValue('displacement', newValue);
                                submitForm()
                            }}
                            getOptionLabel={(option) => {
                                return (option.displacement === '-' ?
                                    option.displacement
                                    :
                                    Number(option.displacement).toFixed(1))
                            }
                            }
                            options={displacements}
                            renderInput={(params) => <TextField {...params}
                                                                inputRef={displacementRef}
                                                                label="Объем двигателя"
                                                                variant={'standard'}/>}
                        >
                        </Autocomplete>}
                    </Grid>
                    : null

            }
            <div style={{alignSelf: 'center'}}>
                <Tooltip title='Для более быстрого выбора вы можете использовать кнопку Enter и стрелки на клавиатуре'>
                    <IconButton size={'small'}>
                        <InfoIcon fontSize={'small'}/>
                    </IconButton>
                </Tooltip>
            </div>
        </Grid>
    )
}

function Home() {
    const workOrders = useSelector(state => state.lists.workOrders);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchCar, setSearchCar] = useState({ plate: null});
    const [searchOrders, setSearchOrders] = useState({start: null, end: null});

    useEffect(() => {
        dispatch(setListsEmpty([]));
        dispatch(setJobs([]));
    }, []);

    const handleSearchCar = useCallback((start, end) => {
        if (!start || !end) {
            setSearchOrders(prev => ({
                ...prev,
                start: null,
                end: null
            }));
            return;
        }
        setSearchOrders(prev => ({
            ...prev,
            start,
            end
        }));
    }, []);

    const debouncedSearchPlate = useMemo(
        () =>
            debounce((plate) => {
                setSearchCar(prev => ({
                    ...prev,
                    plate,
                }));
            }, 750),
        []
    );
    const handleSearchCarPlate = useCallback((plate) => {
        debouncedSearchPlate(plate);
    }, []);
    return (
        <Grid container style={{height: '100%'}}>
            <Stack sx={{m: 1}} direction={'column'} style={{minWidth: '20em', width: '20%'}}>
                <Accordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        sx={{

                            '&.Mui-expanded': { minHeight: 0 },
                            '& .MuiAccordionSummary-content': { m: 0 },
                            '& .MuiAccordionSummary-content.Mui-expanded': { m: 0 },
                        }}
                    >
                        <Stack direction='row' spacing={1}>
                            <Typography variant="subtitle2" sx={{
                                fontSize:'18px'
                            }} gutterBottom>Поиск обращений по госномеру</Typography>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails  sx={{ p: 0, mb:1  }}>
                        <Box sx={{m: 1}}>
                            <LicensePlateInput handle={handleSearchCarPlate}/>
                        </Box>
                        <ListSearchCar search={searchCar} status={'search'}/>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        sx={{

                            '&.Mui-expanded': { minHeight: 0 },
                            '& .MuiAccordionSummary-content': { m: 0 },
                            '& .MuiAccordionSummary-content.Mui-expanded': { m: 0 },
                        }}
                    >
                        <Stack direction='row' spacing={1} alignItems={"center"}>
                            <Typography variant="subtitle2" sx={{
                                fontSize:'18px'
                            }} gutterBottom>Поиск и статистика по закрытым заказ-нарядам</Typography>
                            <Tooltip
                                title={<Typography variant="body1" gutterBottom>
                                    Статистика по закрытым заказ-нарядам за выбранный период (максимально –366 дней)
                                </Typography>}
                                arrow
                                placement="right"
                                componentsProps={{
                                    tooltip: {sx: {borderRadius: 3}},
                                }}
                            >
                                <InfoIcon fontSize={'small'} sx={{color: 'gray', m: 1}}/>
                            </Tooltip>

                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails  sx={{ p: 0, mb:1 }}>
                        <Stack direction='row' spacing={1} sx={{m: 1}}>
                            <DatePickerRangeDays handle={handleSearchCar} day={366}/>
                        </Stack>
                        <ListSearchCar search={searchOrders} status={'success'}/>
                    </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded sx={{ m: 0 }}>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        sx={{

                            '&.Mui-expanded': { minHeight: 0 },
                            '& .MuiAccordionSummary-content': { m: 0 },
                            '& .MuiAccordionSummary-content.Mui-expanded': { m: 0 },
                        }}
                    >
                        <Typography variant="h6" gutterBottom>Недавно открытые</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0 }}>
                        <Typography component="div">
                            <Box className={styles.leftBar} flexGrow={1}>

                                {workOrders.length > 0 ?
                                    /*workOrders.map((order, index) => {
                                        return <CarCard key={index} order={order}/>
                                    })*/
                                    <VirtualizedCarCard data={workOrders} />
                                    :
                                    // <Typography variant={'body1'}>Вы не смотрели работы по автомобилям за последние 3 дня</Typography>
                                    <Alert sx={{m: 1}} severity="info">Вы не смотрели работы по автомобилям за последние 3
                                        дня</Alert>
                                }
                            </Box>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Stack>
            {/*
            <Stack sx={{m: 1}} direction={'column'} style={{minWidth: '20em', width: '20%'}}>
                <Box sx={{m: 1}}>
                    <Stack direction='row' spacing={1}>
                        <Typography variant="h6" gutterBottom>Поиск</Typography>
                        <Tooltip
                            title={<Grid container style={{width: 250}}>
                                <Grid item xs={12}>
                                    <Typography variant="body1" gutterBottom>
                                        Заказ-наряды с заполненным пробегом можно найти по дате и госномеру
                                    </Typography>
                                </Grid>
                            </Grid>}
                            arrow
                            placement="right"
                            componentsProps={{
                                tooltip: {sx: {borderRadius: 3}},
                            }}
                        >
                            <InfoIcon fontSize={'small'} sx={{color: 'gray', m: 1}}/>
                        </Tooltip>

                    </Stack>
                    <Box sx={{mt: 2}}>
                        <LicensePlateInput handle={handleSearchCarPlate}/>
                    </Box>
                </Box>
                <ListSearchCar search={searchCar}/>
                <Box sx={{m: 1}}>
                    <Typography variant={'h5'}>Недавно открытые</Typography>
                </Box>
                <Box className={styles.leftBar} flexGrow={1}>
                    {workOrders.length > 0 ?
                        workOrders.map((order, index) => {
                            return <CarCard key={index} order={order}/>
                        })
                        :
                        // <Typography variant={'body1'}>Вы не смотрели работы по автомобилям за последние 3 дня</Typography>
                        <Alert sx={{m: 1}} severity="info">Вы не смотрели работы по автомобилям за последние 3
                            дня</Alert>
                    }
                </Box>
            </Stack>

         */}
            <Formik initialValues={
                {
                    year: null,
                    make: null,
                    serie: null,
                    model: null,
                    fuel: null,
                    displacement: null,
                }
            }
                    validate={(values) => {
                    }}
                    onSubmit={
                        (values) => {
                            sessionStorage.setItem('form', JSON.stringify(values))
                            navigate('calculator')
                        }
                    }>
                <Grid item xs sx={{m: 1}}>
                    <Typography variant={'h5'}>
                        Выберите транспортное средство
                    </Typography>
                    <ChooseCar/>
                </Grid>
            </Formik>
        </Grid>
    )
}

export default Home